import firebase from 'firebase/app';
import 'firebase/firestore';
import firebaseConfig from "./firebase-config"

var fireDB = firebase.initializeApp(firebaseConfig)


export default fireDB;